import { sentryManual } from "@configs/sentry/manual-sentry";
import { useServerConfig } from "@hooks/useServerConfig";
import useServerInfo from "@hooks/useServerInfo";
import { initDesktopBlocker } from "@utils/desktop-blocker";
import { lazy, useEffect, useState } from "react";
import AppRoutes from "./AppRouter";

const LazyDesktopBlockerPage = lazy(() => import("./main/views/DesktopBlockerPage"));

const {
  shouldBlock: shouldBlockDesktop,
  userAgent,
  triggerSentryEvent,
  context: desktopBlockerContext,
} = initDesktopBlocker(sentryManual);

const AppContent = () => {
  const serverInfo = useServerInfo();
  const { data: serverConfig, isFetching: isFetchingServerConfig } = useServerConfig({ skip: !shouldBlockDesktop });

  const [desktopBlockerTraceId, setDesktopBlockerTraceId] = useState<string>();
  const [showDesktopBlocker, setShowDesktopBlocker] = useState(false);
  // @ts-ignore
  const desktopBlockerEnabled = serverInfo?.securitySettings?.blockDesktopAccess || serverConfig?.desktopBlockerV2;
  const [isCheckingDesktopBlocker, setIsCheckingDesktopBlocker] = useState(shouldBlockDesktop);

  useEffect(() => {
    // Ignore checking if using mobile browser
    if (shouldBlockDesktop) {
      setIsCheckingDesktopBlocker(true);
      // Wait for server info to load
      if (!!serverInfo && !isFetchingServerConfig) {
        if (desktopBlockerEnabled) {
          setDesktopBlockerTraceId(triggerSentryEvent?.() ?? "");
          setShowDesktopBlocker(true);
        }
        setIsCheckingDesktopBlocker(false);
      }
    }
  }, [desktopBlockerEnabled, serverInfo, isFetchingServerConfig]);

  // If detect desktop, wait for server config to check if desktop blocker is enabled
  if (shouldBlockDesktop && isCheckingDesktopBlocker) {
    return null; // wait for server config to load
  }

  // Block desktop if server config is enabled
  if (showDesktopBlocker) {
    return (
      <LazyDesktopBlockerPage
        userAgent={userAgent}
        platform={desktopBlockerContext?.criteria?.platform}
        traceId={desktopBlockerTraceId}
      />
    );
  }

  return <AppRoutes />;
};

export default AppContent;
